import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Register from './Register';

ReactDOM.render(<Register />, document.getElementById('root'));
